// extracted by mini-css-extract-plugin
module.exports = {"stripContainer":"zRTIs","priceDropBackground":"_1UiX8","reservedBackground":"_181h6","tradeInBackground":"_3d2zl","comingSoonBackground":"_1vVjL","label":"_2TjDj"};